import { render, staticRenderFns } from "./FundamentalFormSummary.vue?vue&type=template&id=065db7a0&scoped=true&"
import script from "./FundamentalFormSummary.vue?vue&type=script&lang=js&"
export * from "./FundamentalFormSummary.vue?vue&type=script&lang=js&"
import style0 from "./FundamentalFormSummary.vue?vue&type=style&index=0&id=065db7a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065db7a0",
  null
  
)

export default component.exports